import {colors} from '../../colors/colors';

import type {AvailabilityLevel} from './types';

export const LEVEL_COLORS: Record<AvailabilityLevel, string | undefined> = {
    low: colors.rose,
    medium: colors.yellow,
    high: colors.green,
    unavailable: colors.offWhiteDk,
    noData: colors.greyXlt,
};

export const KEY_ITEMS = [
    {id: 'low', label: 'Low', color: LEVEL_COLORS.low},
    {id: 'medium', label: 'Medium', color: LEVEL_COLORS.medium},
    {id: 'high', label: 'High', color: LEVEL_COLORS.high},
    {id: 'unavailable', label: 'Unavailable', color: LEVEL_COLORS.unavailable},
    {id: 'noData', label: 'No data', color: LEVEL_COLORS.noData},
] as const;
